// Central registry for the native-app hardware-Back contract. Full-screen web
// overlays that want to own the device Back button push a handler here; the
// topmost handler runs when the app reports a Back press. Generic by design so
// new overlays need no native-app change — keep the action vocabulary in sync
// with the app: https://github.com/halalbooking/mobile-app/pull/960
//   web -> app  native_back_arm     (stack 0 -> 1: app starts intercepting Back)
//   web -> app  native_back_disarm  (stack 1 -> 0: app stops intercepting Back)
//   app -> web  native_back         (Back pressed while armed; app did NOT pop)
;(() => {
  const MIN_VERSION = "2.6.0"
  const stack = []

  function arm() {
    window.HB.postMessageForVersion({ action: "native_back_arm" }, MIN_VERSION)
  }

  function disarm() {
    window.HB.postMessageForVersion(
      { action: "native_back_disarm" },
      MIN_VERSION,
    )
  }

  function push(handler) {
    stack.push(handler)
    if (stack.length === 1) arm()
    let unregistered = false
    return () => {
      if (unregistered) return
      unregistered = true
      const index = stack.lastIndexOf(handler)
      if (index !== -1) stack.splice(index, 1)
      if (stack.length === 0) disarm()
    }
  }

  window.addEventListener("message", (event) => {
    let data
    try {
      data = JSON.parse(event.data)
    } catch {
      return
    }
    if (data?.action !== "native_back") return
    stack[stack.length - 1]?.()
  })

  window.HB = window.HB || {}
  window.HB.nativeBack = { push }
})()
